export default "__VITE_ASSET__C$ySlBVa__"